import React, { useState, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronLeft,
  faArrowUpFromBracket,
} from '@fortawesome/free-solid-svg-icons'
import PropTypes from 'prop-types'
import { useOrientation } from '../../../contexts/OrientationContext'
import './AlbumWindow.css'

import closeIcon from '../../../assets/icons/close-icon.svg'
import maximizeIcon from '../../../assets/icons/fullscreen-icon.svg'
import minimizeIcon from '../../../assets/icons/minscreen-icon.svg'
import wallpaperIcon from '../../../assets/icons/Photos/wallpaper-icon.png'
import libraryIcon from '../../../assets/icons/Photos/Photos/library-icon.png'
import wallpaperOutlineIcon from '../../../assets/icons/Photos/Photos/wallpaper-outline-icon.png'
import avatarIcon from '../../../assets/icons/Photos/Photos/avatar-icon.png'
import icon2020 from '../../../assets/icons/Photos/Artwork/2020-icon.png'
import icon2021 from '../../../assets/icons/Photos/Artwork/2021-icon.png'
import icon2022 from '../../../assets/icons/Photos/Artwork/2022-icon.png'
import icon2023 from '../../../assets/icons/Photos/Artwork/2023-icon.png'
import icon2024 from '../../../assets/icons/Photos/Artwork/2024-icon.png'

import image1 from '../../../assets/background/background-1.jpg'
import image2 from '../../../assets/background/background-2.jpg'
import image3 from '../../../assets/background/background-3.jpg'
import image4 from '../../../assets/background/background-4.jpg'
import image5 from '../../../assets/background/background-5.jpg'
import image6 from '../../../assets/background/background-6.png'
import image7 from '../../../assets/background/background-7.png'

import thumbnailImage1 from '../../../assets/background/thumbnail/background-1.jpg'
import thumbnailImage2 from '../../../assets/background/thumbnail/background-2.jpg'
import thumbnailImage3 from '../../../assets/background/thumbnail/background-3.jpg'
import thumbnailImage4 from '../../../assets/background/thumbnail/background-4.jpg'
import thumbnailImage5 from '../../../assets/background/thumbnail/background-5.jpg'
import thumbnailImage6 from '../../../assets/background/thumbnail/background-6.png'
import thumbnailImage7 from '../../../assets/background/thumbnail/background-7.png'

/** MY ARTWORK */
import artwork1 from '../../../assets/artworks/original/2020/2020-1.png'
import artwork2 from '../../../assets/artworks/original/2020/2020-2.png'
import artwork3 from '../../../assets/artworks/original/2021/2021-01-1.png'
import artwork4 from '../../../assets/artworks/original/2021/2021-01-2.png'
import artwork5 from '../../../assets/artworks/original/2021/2021-02.png'
import artwork6 from '../../../assets/artworks/original/2021/2021-05.png'
import artwork7 from '../../../assets/artworks/original/2021/2021-10-1.png'
import artwork8 from '../../../assets/artworks/original/2021/2021-10-2.png'
import artwork9 from '../../../assets/artworks/original/2021/2021-10-3.png'
import artwork10 from '../../../assets/artworks/original/2021/2021-11-01.png'
import artwork11 from '../../../assets/artworks/original/2021/2021-11-02.png'
import artwork12 from '../../../assets/artworks/original/2021/2021-11-03.png'
import artwork13 from '../../../assets/artworks/original/2021/2021-12.png'
import artwork14 from '../../../assets/artworks/original/2022/2022-01-1.png'
import artwork15 from '../../../assets/artworks/original/2022/2022-01-2.png'
import artwork16 from '../../../assets/artworks/original/2022/2022-02-1.png'
import artwork17 from '../../../assets/artworks/original/2022/2022-02-2.png'
import artwork18 from '../../../assets/artworks/original/2022/2022-10.png'
import artwork19 from '../../../assets/artworks/original/2023/2023-02.png'
import artwork20 from '../../../assets/artworks/original/2023/2023-07.png'
import artwork21 from '../../../assets/artworks/original/2023/2023-11.png'

import thumbnailArtwork1 from '../../../assets/artworks/thumbnail/2020/2020-1.png'
import thumbnailArtwork2 from '../../../assets/artworks/thumbnail/2020/2020-2.png'
import thumbnailArtwork3 from '../../../assets/artworks/thumbnail/2021/2021-01-1.png'
import thumbnailArtwork4 from '../../../assets/artworks/thumbnail/2021/2021-01-2.png'
import thumbnailArtwork5 from '../../../assets/artworks/thumbnail/2021/2021-02.png'
import thumbnailArtwork6 from '../../../assets/artworks/thumbnail/2021/2021-05.png'
import thumbnailArtwork7 from '../../../assets/artworks/thumbnail/2021/2021-10-1.png'
import thumbnailArtwork8 from '../../../assets/artworks/thumbnail/2021/2021-10-2.png'
import thumbnailArtwork9 from '../../../assets/artworks/thumbnail/2021/2021-10-3.png'
import thumbnailArtwork10 from '../../../assets/artworks/thumbnail/2021/2021-11-01.png'
import thumbnailArtwork11 from '../../../assets/artworks/thumbnail/2021/2021-11-02.png'
import thumbnailArtwork12 from '../../../assets/artworks/thumbnail/2021/2021-11-03.png'
import thumbnailArtwork13 from '../../../assets/artworks/thumbnail/2021/2021-12.png'
import thumbnailArtwork14 from '../../../assets/artworks/thumbnail/2022/2022-01-1.png'
import thumbnailArtwork15 from '../../../assets/artworks/thumbnail/2022/2022-01-2.png'
import thumbnailArtwork16 from '../../../assets/artworks/thumbnail/2022/2022-02-1.png'
import thumbnailArtwork17 from '../../../assets/artworks/thumbnail/2022/2022-02-2.png'
import thumbnailArtwork18 from '../../../assets/artworks/thumbnail/2022/2022-10.png'
import thumbnailArtwork19 from '../../../assets/artworks/thumbnail/2023/2023-02.png'
import thumbnailArtwork20 from '../../../assets/artworks/thumbnail/2023/2023-07.png'
import thumbnailArtwork21 from '../../../assets/artworks/thumbnail/2023/2023-11.png'

function AlbumWindow({ onClose, onChangeBackground }) {
  const { isPortrait } = useOrientation()
  const [isMaximized, setIsMaximized] = useState(false)
  const [selectedMenu, setSelectedMenu] = useState('library') // 默认选中 Library
  const [viewImage, setViewImage] = useState(null)
  const [isPopupVisible, setIsPopupVisible] = useState(false)
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 })

  const buttonRef = useRef(null)

  const toggleMaximize = () => {
    setIsMaximized(!isMaximized)
  }

  const handleMenuClick = key => {
    setSelectedMenu(key)
  }

  const handleImageClick = image => {
    setViewImage(image)
  }

  const handleExitImageView = () => {
    setViewImage(null)
  }

  const handleSetBackground = () => {
    if (viewImage && onChangeBackground) {
      onChangeBackground(viewImage)
    }
    setIsPopupVisible(false)
  }

  const handlePopupToggle = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect()
      setPopupPosition({
        top: rect.bottom + window.scrollY + 8,
        left: rect.left + rect.width / 2 + window.scrollX,
      })
    }
    setIsPopupVisible(!isPopupVisible)
  }

  const handleClickOutside = event => {
    if (buttonRef.current && !buttonRef.current.contains(event.target)) {
      setIsPopupVisible(false)
    }
  }

  React.useEffect(() => {
    if (isPopupVisible) {
      window.addEventListener('click', handleClickOutside)
    }
    return () => {
      window.removeEventListener('click', handleClickOutside)
    }
  }, [isPopupVisible])

  const menuItems = [
    {
      title: 'Photos',
      items: [
        { key: 'library', label: 'Library', icon: libraryIcon },
        { key: 'wallpaper', label: 'Wallpaper', icon: wallpaperOutlineIcon },
        { key: 'avatar', label: 'Avatar', icon: avatarIcon },
      ],
    },
    {
      title: 'My Artwork',
      items: [
        { key: '2020', label: '2020', icon: icon2020 },
        { key: '2021', label: '2021', icon: icon2021 },
        { key: '2022', label: '2022', icon: icon2022 },
        { key: '2023', label: '2023', icon: icon2023 },
        { key: '2024', label: '2024', icon: icon2024 },
      ],
    },
  ]

  const libraryImages = [
    {
      thumbnail: thumbnailImage1,
      original: image1,
      category: 'wallpaper',
    },
    {
      thumbnail: thumbnailImage2,
      original: image2,
      category: 'wallpaper',
    },
    {
      thumbnail: thumbnailImage3,
      original: image3,
      category: 'wallpaper',
    },
    {
      thumbnail: thumbnailImage4,
      original: image4,
      category: 'wallpaper',
    },
    {
      thumbnail: thumbnailImage5,
      original: image5,
      category: 'avatar',
    },
    {
      thumbnail: thumbnailImage6,
      original: image6,
      category: 'wallpaper',
    },
    {
      thumbnail: thumbnailImage7,
      original: image7,
      category: 'avatar',
    },
    { thumbnail: thumbnailArtwork1, original: artwork1, category: '2020' },
    { thumbnail: thumbnailArtwork2, original: artwork2, category: '2020' },
    { thumbnail: thumbnailArtwork3, original: artwork3, category: '2021' },
    { thumbnail: thumbnailArtwork4, original: artwork4, category: '2021' },
    { thumbnail: thumbnailArtwork5, original: artwork5, category: '2021' },
    { thumbnail: thumbnailArtwork6, original: artwork6, category: '2021' },
    { thumbnail: thumbnailArtwork7, original: artwork7, category: '2021' },
    { thumbnail: thumbnailArtwork8, original: artwork8, category: '2021' },
    { thumbnail: thumbnailArtwork9, original: artwork9, category: '2021' },
    { thumbnail: thumbnailArtwork10, original: artwork10, category: '2021' },
    { thumbnail: thumbnailArtwork11, original: artwork11, category: '2021' },
    { thumbnail: thumbnailArtwork12, original: artwork12, category: '2021' },
    { thumbnail: thumbnailArtwork13, original: artwork13, category: '2021' },
    { thumbnail: thumbnailArtwork14, original: artwork14, category: '2022' },
    { thumbnail: thumbnailArtwork15, original: artwork15, category: '2022' },
    { thumbnail: thumbnailArtwork16, original: artwork16, category: '2022' },
    { thumbnail: thumbnailArtwork17, original: artwork17, category: '2022' },
    { thumbnail: thumbnailArtwork18, original: artwork18, category: '2022' },
    { thumbnail: thumbnailArtwork19, original: artwork19, category: '2023' },
    { thumbnail: thumbnailArtwork20, original: artwork20, category: '2023' },
    { thumbnail: thumbnailArtwork21, original: artwork21, category: '2023' },
  ]

  const renderLibraryContent = () => {
    const filteredImages =
      selectedMenu === 'library'
        ? libraryImages // 显示所有图片
        : libraryImages.filter(
            image => image.category.toLowerCase() === selectedMenu
          )

    return (
      <div className="album-window-library-content">
        <div className="album-window-library-grid">
          {filteredImages.map(image => (
            <div
              key={image.original}
              className="album-window-library-item"
              onClick={() => handleImageClick(image.original)}
            >
              <img
                src={image.thumbnail}
                alt={`Library ${image.original}`}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    )
  }

  const renderMenu = () => (
    <div className="album-window-menu">
      {menuItems.map((menu, index) => (
        <div key={index} className="menu-section">
          <div className="menu-title">{menu.title}</div>
          <div className="menu-items">
            {menu.items.map(item => (
              <div
                key={item.key}
                className={`album-window-menu-item ${
                  selectedMenu === item.key ? 'active' : ''
                }`}
                onClick={() => handleMenuClick(item.key)}
              >
                <img
                  src={item.icon}
                  alt={`${item.label} Icon`}
                  className="menu-item-icon"
                />
                {item.label}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )

  const renderContent = () => {
    if (viewImage) {
      return (
        <div className="album-window-library-content single-image-container">
          <img src={viewImage} alt="Full view" className="fullscreen-image" />
        </div>
      )
    }
    return renderLibraryContent() // 始终根据 `selectedMenu` 显示相应内容
  }

  return (
    <div className={`album-window-overlay ${isPortrait ? 'portrait' : ''}`}>
      <div className={`album-window ${isMaximized ? 'maximized' : ''}`}>
        <div className="album-window-sidebar">
          <div className="album-window-buttons">
            <img
              className="close-icon"
              onClick={onClose}
              src={closeIcon}
              alt="Close"
              style={{ cursor: 'pointer', width: '12px', height: '12px' }}
            />
            <img
              className="close-icon"
              onClick={toggleMaximize}
              src={isMaximized ? minimizeIcon : maximizeIcon}
              alt="Close"
              style={{ cursor: 'pointer', width: '12px', height: '12px' }}
            />
          </div>
          {renderMenu()}
        </div>
        <div className="album-window-content">
          {viewImage ? (
            <div className="album-window-content-header-view-image">
              <button
                className="exit-fullscreen-button"
                onClick={handleExitImageView}
              >
                <FontAwesomeIcon icon={faChevronLeft} />
              </button>
              <button
                className="exit-fullscreen-button"
                onClick={handlePopupToggle}
                ref={buttonRef}
              >
                <FontAwesomeIcon icon={faArrowUpFromBracket} />
              </button>
              {isPopupVisible && (
                <div
                  className="popup"
                  style={{
                    position: 'absolute',
                    top: `${popupPosition.top}px`,
                    left: `${popupPosition.left}px`,
                    transform: 'translateX(-50%)',
                    zIndex: 1000,
                  }}
                >
                  <button onClick={handleSetBackground}>
                    <img
                      src={wallpaperIcon}
                      alt="Wallpaper Icon"
                      style={{ marginRight: '5px', height: '16px' }}
                    />
                    Set Wallpaper
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div className="album-window-content-header">
              <div className="album-window-content-header-title">
                {menuItems.find(item => item.key === selectedMenu)?.label ||
                  'Library'}
              </div>
            </div>
          )}
          {renderContent()}
        </div>
      </div>
    </div>
  )
}

AlbumWindow.propTypes = {
  onClose: PropTypes.func.isRequired,
  onChangeBackground: PropTypes.func,
}

export default AlbumWindow
